import * as React from "react"
import { Eye, EyeOff } from "lucide-react"

import { cn } from "@/lib/utils"
import { TarihInput } from "@/components/TarihInput"

const BASE = "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm";

const SifreInput = React.forwardRef(({ className, ...props }, ref) => {
  const [goster, setGoster] = React.useState(false);
  const tid = props["data-testid"];
  return (
    <div className="relative w-full">
      <input type={goster ? "text" : "password"} className={cn(BASE, className, "pr-10")} ref={ref} {...props} />
      <button type="button" tabIndex={-1} data-testid={tid ? `${tid}-goster` : "sifre-goster"} aria-label={goster ? "Şifreyi gizle" : "Şifreyi göster"} title={goster ? "Şifreyi gizle" : "Şifreyi göster"}
        onClick={() => setGoster((g) => !g)} className="absolute right-1 top-1/2 -translate-y-1/2 p-1.5 rounded-md text-muted-foreground hover:text-foreground hover:bg-white/10 transition-colors">
        {goster ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
});
SifreInput.displayName = "SifreInput"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  if (type === "date") return <TarihInput className={className} {...props} />;
  if (type === "password") return <SifreInput className={className} ref={ref} {...props} />;
  if (type === "number") return <input type="number" inputMode="decimal" className={cn(BASE, className)} ref={ref} onWheel={(e) => e.currentTarget.blur()} {...props} />;
  return <input type={type} className={cn(BASE, className)} ref={ref} {...props} />;
})
Input.displayName = "Input"

export { Input }
